import React from "react";

interface OdqLinksRowProps {
    /** Transporter ID, used to scope the T.corp ticket search. */
    referenceId: string;
}

/** T.corp ticket search scoped to this transporter, across all statuses and severities. */
export const buildTcorpUrl = (referenceId: string) => {
    const ticketSearchFilter = `{"AND":{"status":{"OR":["Assigned",{"OR":["Researching",{"OR":["Work In Progress",{"OR":["Pending",{"OR":["Resolved","Closed"]}]}]}]}]},"AND":{"severity":{"OR":["1",{"OR":["2",{"OR":["2.5",{"OR":["3",{"OR":["4",{"OR":["5","N"]}]}]}]}]}]},"keyword":"( ${referenceId})"}}}`;
    return `https://t.corp.amazon.com/issues?q=${encodeURIComponent(ticketSearchFilter)}`;
};

/**
 * OdqLinksRow - The "Links:" row of external references shown under Case Details.
 * Uses the shared `lighthouse-field-*` classes so its label aligns with the rows above;
 * the legacy `odq-links-row` carries a border tuned for the classic ODQ card.
 */
const OdqLinksRow: React.FC<OdqLinksRowProps> = ({referenceId}) => (
    <div className="lighthouse-field-readonly odq-lh-links" data-testid="odq-links-row">
        <span className="lighthouse-field-label">Links:</span>
        <span className="lighthouse-field-value">
            <a href={buildTcorpUrl(referenceId)} target="_blank" rel="noreferrer">T.corp</a>
            <a href="https://www.bing.com/maps" target="_blank" rel="noreferrer">Bing Maps</a>
        </span>
    </div>
);

export default OdqLinksRow;
